import { ArrowRight } from 'lucide-react';
import { Handshake } from 'lucide-react';

/**
 * ReferralBanner - Referral program promotion section
 * Formal/Modern design - minimal colors
 */
const ReferralBanner = () => {
  return (
    <section className="py-14 bg-gray-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <p className="text-sm tracking-[0.2em] text-gray-500 mb-3">REFERRAL PROGRAM</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">
            Bring Friends & Family <span className="text-gray-500">&</span> Get Paid
          </h2>
          <p className="text-base text-gray-400 max-w-xl mx-auto">
            You don't need to invest to earn. Refer people and get rewarded. <strong className="text-white">Everyone earns.</strong>
          </p>
        </div>
        
        {/* Stats Grid - Monochrome */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
          {/* Card 1 */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center hover:border-gray-600 transition-colors">
            <div className="text-3xl font-bold text-white mb-2">%</div>
            <p className="text-white font-medium mb-1 text-sm">Investor Referrals</p>
            <p className="text-xs text-gray-500">AAC Real Estate I Fund</p>
          </div>
          
          {/* Card 2 - Handshake Icon */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center hover:border-gray-600 transition-colors">
            <div className="flex justify-center mb-2">
              <Handshake className="text-white" size={32} />
            </div>
            <p className="text-white font-medium mb-1 text-sm">Better Together</p>
            <p className="text-xs text-gray-500">More collaboration = better deals</p>
          </div>
          
          {/* Card 3 */}
          <div className="bg-gray-800 border border-gray-700 rounded-xl p-6 text-center hover:border-gray-600 transition-colors">
            <div className="text-3xl font-bold text-white mb-2">%</div>
            <p className="text-white font-medium mb-1 text-sm">Deal Referrals</p>
            <p className="text-xs text-gray-500">Off-Market Properties</p>
          </div>
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <a 
            href="https://t.me/+gbLD_8i3AbIzMTY0"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white text-gray-900 px-6 py-3 font-bold rounded-lg hover:bg-gray-100 transition-all duration-200 text-sm"
          >
            Start Referring & Earning
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReferralBanner;
